module.exports = __webpack_public_path__ + "img/visa-qr.429b3373.png";